import * as React from 'react';
import { Field } from 'formik';

import { GeneralInformationFormData } from './types';
import TextArea from '../input-textarea';
import TextInput from '../input-text';

import CheckboxInput from '../input-checkbox';

interface OwnProps {
    values: GeneralInformationFormData;
    handleChange: (e: React.ChangeEvent<any>) => void;
}

export class AboutCard extends React.Component<OwnProps, {}> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        return (
            <div className='VenueManagement--card'>
                <div className='VenueManagement--card--header'>About</div>
                <div className='VenueManagement--card--body'>
                    <div className='VenueManagement--row'>
                        <div className='VenueManagement--col'>
                            <div className=''>
                                <Field
                                    label='Venue name'
                                    component={TextInput}
                                    name='venue_name'
                                    value={this.props.values.venue_name}
                                    onChange={this.props.handleChange}
                                />
                            </div>
                        </div>
                        <div className='VenueManagement--col-divider' />
                        <div className='VenueManagement--col'>
                            <div className='VenueManagement--inline-field--container'>
                                <div className='VenueManagement--inline-field--label'>Venue type:</div>
                                <div>
                                    <Field
                                        label='Wedding venue'
                                        component={CheckboxInput}
                                        name='is_wedding_venue'
                                        checked={this.props.values.is_wedding_venue}
                                        onChange={this.props.handleChange}
                                    />
                                    <Field
                                        label='Rehearsal dinner'
                                        component={CheckboxInput}
                                        name='is_rd_venue'
                                        checked={this.props.values.is_rd_venue}
                                        onChange={this.props.handleChange}
                                    />
                                    <Field
                                        label='Destination wedding'
                                        component={CheckboxInput}
                                        name='is_dw_venue'
                                        checked={this.props.values.is_dw_venue}
                                        onChange={this.props.handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='VenueManagement--row'>
                        <div className='VenueManagement--textarea-container'>
                            <Field label='Description' component={TextArea} name='description' />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
